import PropTypes from "prop-types";
import styles from "./NextStep.module.scss";

export enum TradeInSteps {
  START = "Start a new quote or close the window",
  FIND_DEVICE = "Information about your device",
  PAYOUT = "See your payout options",
  REVIEW = "Review and Confirmation",
  CHECKOUT = "Checkout",
}

type Props = {
  step?: TradeInSteps;
};
export const NextStep = ({ step }: Props) => {
  if (!step) {
    return null;
  }
  return (
    <div className={styles.nextStep} data-testid="nextStep">
      <p className={styles.nextStep__header}>Next Step</p>
      <p className={styles.nextStep__bodyText}>{step}</p>
    </div>
  );
};

NextStep.propTypes = {
  step: PropTypes.string,
};

export default NextStep;
